import React from 'react';
import { Avatar, Typography } from '@material-ui/core';

import { UserRole } from 'context/user/userContext/UserContext.types';
import { InstallerIcon, ManufacturerIcon, OwnerIcon, VerifierIcon } from '../icons';

import { ProfileHeaderProps } from './ProfileHeader.types';
import { useStyles } from './ProfileHeader.styles';

export const ProfileHeader = ({ name, email, role, avatar, address }: ProfileHeaderProps) => {
  const classes = useStyles({ role });

  const roleIcon = {
    [UserRole.Manufacturer]: <ManufacturerIcon color="inherit" />,
    [UserRole.GoverningBody]: <ManufacturerIcon color="inherit" />,
    [UserRole.Owner]: <OwnerIcon color="inherit" />,
    [UserRole.Installer]: <InstallerIcon color="inherit" />,
    [UserRole.Verifier]: <VerifierIcon color="inherit" />,
  };

  return (
    <div className={classes.container}>
      <div className={classes.roleIndicator}>
        <Avatar src={avatar} className={classes.avatar} />
        <div className={classes.role}>{roleIcon[role]}</div>
      </div>
      <Typography className={classes.title}>{name}</Typography>
      <Typography className={classes.subtitle}>{email}</Typography>
      <Typography className={classes.subtitle}>{address}</Typography>
    </div>
  );
};
